import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Items = lazy(() => import('./items.component'));
const ItemDetail = lazy(() => import('./item-detail/item-detail.component'));

export function ItemsRoutes() {
    return (
        <Route path='items'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <Items />
                    </AsyncComponent>
                }
            />
            <Route path=':itemId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ItemDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
